/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

    document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
//       alert(quantity);
  });

function primaryNavActiveLink() {
    // Get section and highlight nav items
    var here = location.href.replace(/(\?.*)$/, '').split('/').slice(3);
    var pageURL;
    var parts = [{
        "text": 'Home',
        "link": '/'
    }];

    for (var j = 0; j < here.length; j++) {
      var part = here[j];
      var pageName = part.toLowerCase();
      //console.log(pageName);
      //pageName = part.charAt(0).toUpperCase() + part.slice(1);
      
      if(pageName=="newsletter") {
      console.log(pageName);
        document.querySelector("body").classList.add('page-newsletter');
      }
//         parts.push({
//             "text": pageName,
//             "link": link
//         });
    }
}

document.addEventListener("DOMContentLoaded", function(){
 
  // Replace footer link with button
  var element = document.querySelector(".footer__block-item--text a");
  element.classList.add('button', 'button--primary');

  var footer1element = document.querySelector(".footer__block-item--text");
  footer1element.innerHTML = footer1element.innerHTML + '<p class="footer-email-link"><svg focusable="false" class="icon icon--bi-email" viewBox="0 0 22 22" role="presentation"><g fill="none" fill-rule="evenodd"><path stroke="#2a9d8f" d="M.916667 10.08333367l3.66666667-2.65833334v4.65849997zm20.1666667 0L17.416667 7.42500033v4.65849997z"></path><path stroke="#1a1a1a" stroke-width="1.5" d="M4.58333367 7.42500033L.916667 10.08333367V21.0833337h20.1666667V10.08333367L17.416667 7.42500033"></path><path stroke="#1a1a1a" stroke-width="1.5" d="M4.58333367 12.1000003V.916667H17.416667v11.1833333m-16.5-2.01666663L21.0833337 21.0833337m0-11.00000003L11.0000003 15.5833337"></path><path d="M8.25000033 5.50000033h5.49999997M8.25000033 9.166667h5.49999997" stroke="#2a9d8f" stroke-width="1.5" stroke-linecap="square"></path></g></svg><a href="mailto:askus@alongcamequilting.com">askus@alongcamequilting.com</a></p>';
  
  // Replace blog landing link with button
  var blogelement = document.querySelector(".blog-sidebar__item--text a");
  if(blogelement) {
  blogelement.classList.add('button', 'button--primary');
  }

primaryNavActiveLink();


});

